import PropTypes from 'prop-types';
import React from 'react';

import Button, { TYPES } from 'components/Button';
import { SecondaryHeading } from 'components/Headings';
import Paragraph from 'components/Paragraph';
import { largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const SHOP_MEN_LINK = '/collections/mens';
const SHOP_WOMEN_LINK = '/collections/womens';

const NotFound = ({ trackEvent }) => {
  const trackCTAClick = (eventLabel, eventLocation) => () =>
    trackEvent({
      eventLabel,
      eventLocation,
    });
  return (
    <div className="page-404">
      <div className="container">
        <SecondaryHeading>{I18n.localize('not-found.heading')}</SecondaryHeading>
        <Paragraph className="NotFoundSubheader">{I18n.localize('not-found.subheading')}</Paragraph>
        <div className="ShopTeam">
          <Button
            type={TYPES.DEFAULT}
            className="TeamButton MenButton"
            linkTo={SHOP_MEN_LINK}
            onClick={trackCTAClick('Shop Men', SHOP_MEN_LINK)}
          >
            {I18n.localize('not-found.men-button')}
          </Button>
          <Button
            type={TYPES.DEFAULT}
            className="TeamButton WomenButton"
            linkTo={SHOP_WOMEN_LINK}
            onClick={trackCTAClick('Shop Women', SHOP_WOMEN_LINK)}
          >
            {I18n.localize('not-found.women-button')}
          </Button>
        </div>
      </div>

      <style jsx>{`
        .page-404 {
          background-color: ${Theme.get('colors-black-10')};
        }

        .container {
          margin: 0 auto;
          text-align: center;
          padding: ${Theme.get('spacing') * 12}px ${Theme.get('spacing') * 4}px
            ${Theme.get('spacing') * 8}px;
        }

        .ShopTeam {
          display: flex;
          justify-content: center;
          flex-direction: column;
          gap: ${Theme.get('spacing-px')};
          margin-top: ${Theme.get('spacing') * 5}px;
          width: 100%;
        }

        @media ${largeUp} {
          .container {
            padding: ${Theme.get('spacing') * 21}px ${Theme.get('spacing') * 4}px
              ${Theme.get('spacing') * 12}px;
          }
          .ShopTeam {
            width: fit-content;
            flex-direction: row;
            margin: ${Theme.get('spacing') * 5}px auto 0;
          }
          .TeamButton {
            width: 193px;
          }
        }
      `}</style>
      <style jsx global>{`
        .Paragraph.NotFoundSubheader {
          margin: ${Theme.get('spacing-px')} auto 0;
        }
        .Button.TeamButton {
          margin: auto;
          width: 100%;
        }
        @media ${largeUp} {
          .Button.TeamButton {
            width: 193px;
          }
          .Paragraph.NotFoundSubheader {
            margin: ${Theme.get('spacing') * 3}px auto 0;
          }
        }
      `}</style>
    </div>
  );
};

NotFound.propTypes = {
  trackEvent: PropTypes.func.isRequired,
};

export default NotFound;
